import DrawingFilesManagement from './DrawingFilePermissionSettingContainer';

export default DrawingFilesManagement;
